import { paymentStatusesEn } from './statuses'
import { cancellationReasonsEn } from './cancellationReasons'

export const translationEn = {
  ...paymentStatusesEn,
  ...cancellationReasonsEn,
  // Company Code Form
  welcome: 'Welcome',
  companyCodeInfo:
    'Enter your Company code to create a new report, or check the status of a previously submitted report.',
  companyCodeLabel: 'Company access code',
  companyCodeInputPlaceholder: 'Enter access code to create new Report',
  companyCodeNotFound:
    'We could not find a company with that code. Please check it and try again.',
  statusOfExistingReport: 'Status of existing Report',
  createNewReport: 'Create new Report',
  companyCode: 'Company Code',

  // Access Report Modal
  accessReportModalTitle: 'Unique Code required to access',
  accessReportModalText:
    'The moment you submitted the report you were given a unique code. Please paste the code into the input field below.',
  accessReportModalLabel: 'Unique Code',
  accessReportModalPlaceholder: 'Insert access code',
  accessReportModalCancelBtn: 'Cancel',
  accessReportModalChecklBtn: 'Check Report',

  // Save Token Modal
  saveTokenTitle: 'The report was submitted. Save the following code:',
  saveTokenImportant: 'IMPORTANT:',
  saveTokenImportantNote:
    'Save the code below and store it securely. Do not share the code with anyone. With this code you will be able to access your report to follow up on its progress and see messages.',
  saveTokenUniqueCodeLabel: 'Your Unique Code',
  saveTokenReceivedReport:
    'We have received your report and will get back to you as soon as possible.',
  saveTokenReportInfo:
    'You can download/export your submitted report below, or click "Complete" to finish up.',
  saveTokenExportBtn: 'Export Report',
  saveTokenCompleteBtn: 'Complete',

  // Delete Resource Modal
  areYouSureWantToDelete: 'Are you sure you want to delete this user?',
  areYouSureWantToDeleteThisCategory:
    'Are you sure you want to delete this category?',
  areYouSureWantToDeleteThisBranch:
    'Are you sure you want to delete this branch?',
  yesIamSure: "Yes, I'm sure",
  noCancel: 'No, cancel',

  // Resolution Option Modal
  areYouSureWantToCloseThisCase: 'Are you sure you want to close this case?',
  youAreAboutToCloseThisCase: 'You are about to close this case',
  theCaseWillBe: 'The case will be',
  howWouldYouLikeToResolveThisCase: 'How would you like to resolve this case?',
  yesCloseTheCase: 'Yes, Close the case',
  noIamNotReady: "No, I'm not ready",
  archived: 'Archived',
  resolved: 'Resolved',

  // Report Form
  reportAnOccurrenceText:
    'Use this form to report any unexpected incidents of various misconduct, fraud or compliance violations that are against organization’s policies and procedures. ReportAll form requests information that is relevant to determine whether and how to conduct an investigation. Confidentiality is highly protected and compliance officers are obliged to protect any kind of personal information.',
  makeReport: 'Make Report',
  checkReport: 'Check Report',
  review: 'Review',
  startReport: 'Start Report',
  typeOfReport: 'Type of Report',
  category: 'Category',
  branch: 'Branch',
  fullName: 'Full Name',
  telephone: 'Telephone',
  questions: 'Questions',
  whenDidTheIncidentOccur: 'When did the incident occur?',
  isTheIncidentStillOngoing: 'Is the incident still ongoing?',
  whereDidTheIncidentOccur: 'Where did the incident occur?',
  whoIsInvolvedAndWhatIsTheirCapacity:
    'Who is involved and what is their capacity?',
  nameSurnameAndTheirCapacity: 'Name Surname and their capacity',
  fullDescriptionOfTheIncident: 'Full Description of the Incident',
  regular: 'Regular',
  anonymous: 'Anonymous',
  attachments: 'Attachments',
  uploadFilesTitle: 'You can upload any files related to your Report',
  dragHere: 'Drag here to Upload Files',
  supportedFiles: 'Supported Files',
  addFile: 'Add File',
  reportAnOccurrence: 'Report an occurence',
  anonymousReporting: 'Anonymous reporting',
  regularReporting: 'Regular reporting',
  chooseIncidentcategory: 'Choose incident category',
  choose: 'Choose',
  anonymousText:
    'This Reporting is anonymous, since it does not require any personal data or/and contact details from the complainant. Please note that in this case, follow up on your Report is allowed only through the access code provided to you upon submission of the Report.',
  regularText:
    'This Reporting may ask your personal data or/and contact details prior to be submitted. Please note that, apart from your name, such information is not obligatory. In any case your Report will be treated with utmost confidentiality.',
  optional: 'optional',
  back: 'Back',
  nextStep: 'Next Step',
  submitReport: 'Submit Report',
  noAttachmentsFound: 'No attachments found',
  textHere: 'Text Here',
  freeTextSmallField: 'Free Text Small Field',
  freeTextLargeField: 'Free Large Text Field',
  details: 'Details',
  assignTo: 'Assign To',
  caseOverview: 'Case Overview',
  activityLog: 'Activity Log',
  submit: 'Submit',
  search: 'Search',
  yes: 'Yes',
  no: 'No',
  writeYourFullName: 'Write your full name',
  writeYourEmail: 'Write your email',
  writeYourTelephone: 'Write your telephone',
  writeThePlaceOfTheIncident: 'Write the place of the incident',
  addTheNamesOfThePeopleInvolved: 'Add the names of the people involved',
  describeIncident:
    'Please describe the incident (What happened? How it happened? etc.) Be as specific as possible.',
  report: 'Report',
  export: 'Export',
  caseDetails: 'Case Details',
  yourMessages: 'Your Messages',
  yourMessagesInfo:
    'Here you can contact the compliance officer undertaking your case, to add more information regarding your report.',
  UNASSIGNED: 'Unassigned',
  IN_PROGRESS: 'In Progress',
  CLOSED: 'Closed',
  TOTAL: 'Total',
  selectBranch: 'Select Branch',

  // Navigation
  dashboard: 'Dashboard',
  reports: 'Reports',
  users: 'Users',
  settings: 'Settings',
  statistics: 'Statistics',
  categories: 'Categories',
  branches: 'Branches',

  // Admin
  newUser: 'New User',
  editUser: 'Edit User',
  saveNewUser: 'Save New User',
  userName: 'Username',
  firstName: 'First Name',
  lastName: 'Last Name',
  password: 'Password',
  position: 'Position',
  language: 'Language',
  newCategory: 'New Category',
  newBranch: 'New branch',
  editCategory: 'Edit Category',
  editBranch: 'Edit Branch',
  insertCategory: 'Insert Category',
  insertName: 'Insert Name',
  saveCategory: 'Save Category',
  noCategoriesFound: 'No categories found',
  noDataFound: 'No data found',
  changePassword: 'Change Password',
  updateCompanyName: 'Update Company Name',
  updatePrivacyPolicy: 'Update Privacy Policy',
  enterLink: 'Enter Privacy Policy Link',
  updateLogo: 'Update Logo',
  companyLogo: 'Company Logo',

  // Compliance Officer
  complianceOfficer: 'Compliance Officer',
  visibility: 'Visibility',
  created: 'Created',
  status: 'Status',
  overviewStatistics: 'Overview Statistics',
  complianceOfficerNotes: 'Compliance Officer Notes',
  complianceOffcerNoteCreatedBy: 'Compliance Officer Note created by:',
  youHaventAddedNotes: "You haven't added any notes to this case yet.",
  onlyAssignedCoOfficerCanViewMessages:
    'Only the assigned Compliance Officer can view the messages.',
  characterLimit: 'Character Limit',
  noteLimit: 'Message must be at most 320 characters',
  closeCase: 'Close Case',
  resolutionOption: 'Resolution Option',
  archivedClosed: 'Archive (Closed)',
  resolvedClosed: 'Resolve (Closed)',
  caseClosed: 'Case Closed',
  caseHasBeenClosed: 'Case has been closed',
  failedToCloseCase: 'Failed to close case',
  REPORT_CREATED: 'Report Created',
  COMPLIANCE_OFFICER_ASSIGNED: 'Compliance Officer Assigned:',
  REPORT_STATUS_CHANGED: 'Report Status Changed:',
  REPORT_NOTE_CREATED: 'Report Note Created',
  REPORT_EDITED: 'Report Edited',

  // Table
  showing: 'Showing',
  to: 'to',
  entries: 'entries',
  of: 'of',
  pages: 'pages',
  ANONYMOUS: 'Anonymous',
  noReportsFound: 'No Reports Found',
  noUsersFound: 'No Users Found',

  // Charts
  mostReportedCategories: 'Most reported categories',
  conclusionType: 'Conclusion type',
  numberNatureOfReports: 'Number / Nature of Reports',
  total: 'All Reports',
  other: 'Other',
  noDataFoundForTheSelectedPeriod: 'No data found for the selected period',

  // Toast messages
  copiedToClipboard: 'Copied to clipboard',
  aUserWithThisEmailAlreadyExists: 'A user with this email already exists',
  aUserWithThisUsernameAlreadyExists:
    'A user with this username already exists',
  failedToCreateUser: 'Failed to create user',
  userHasBeenCreated: 'User has been created',
  userHasBeenUpdated: 'User has been updated',
  failedToUpdateUser: 'Failed to update user',
  userHasBeenDeleted: 'User has been deleted',
  failedToDeleteUser: 'Failed to delete user',
  failedToSubmitNote: 'Failed to submit note',
  failedToLoadReports: 'Failed to load reports',
  failedToCreateCategory: 'Failed to create category',
  categoryHasBeenCreated: 'Category has been created',
  categoryHasBeenDeleted: 'Category has been deleted',
  failedToDeleteCategory: 'Failed to delete category',
  categoryHasBeenUpdated: 'Category has been updated',
  branchHasBeenUpdated: 'Branch has been updated',
  failedToUpdateBranch: 'Failed to update branch',
  branchHasBeenDeleted: 'Branch has been deleted',
  failedToDeleteBranch: 'Failed to delete branch',
  categoryHasAttachedReports_one:
    'Cannot be deleted: {{count}} report is filed under this category.',
  categoryHasAttachedReports_other:
    'Cannot be deleted: {{count}} reports are filed under this category.',
  branchHasAttachedReports_one:
    'Cannot be deleted: {{count}} report is filed under this branch.',
  branchHasAttachedReports_other:
    'Cannot be deleted: {{count}} reports are filed under this branch.',
  attachedReportsUnknown: 'Not available until the report list has loaded.',
  failedToUpdateCategory: 'Failed to update category',
  branchHasBeenCreated: 'Branch has been created',
  failedToCreateBranch: 'Failed to create branch',
  submitFailed: 'Submit Failed',
  aResetLinkHasBeenSentToYourEmail: 'A reset link has been sent to your email.',
  InvalidUsernameOrPassword: 'Invalid Username or Password',
  humanVerificationFailed: 'Human verification failed. Please try again.',
  yourPasswordHasBeenResetsussfully:
    'Your password has been reset successfully.',
  failedToResetPassword: 'Failed to reset password',
  yourPasswordHasBeenChanged: 'Your password has been changed successfully.',
  failedToChangePassword: 'Failed to change password',
  companyNameHasBeenUpdated: 'Company name has been updated',
  failedToUpdateCompanyName: 'Failed to update company name',
  sessionExpired: 'Your session has expired. Please login again.',
  failedToSendMessage: 'Failed to send message',
  failedToLoadMessages: 'Failed to load messages',
  privacyPolicyHasBeenUpdated: 'Privacy Policy has been updated',
  failedToUpdatePrivacyPolicy: 'Failed to update privacy policy',
  logoHasBeenUpdated: 'Logo has been updated',
  failedToUpdateLogo: 'Failed to update logo',
  caseAssigned: 'Case has been assigned successfully',

  // Error messages
  somethingWentWrongFailedToLoadNotes:
    'Something went wrong, failed to load notes',

  //Validation Messages
  requiredField: 'Required Field',
  invalidEmail: 'Invalid Email',
  invalidPhone: 'Invalid Telephone',

  logout: 'Log out',
  logIn: 'Log in',
  enterCredentials: 'Enter your Credentials to access your account.',
  resetPassword: 'Reset Password',
  forgotPassword: 'Forgot Password?',
  insertUsername: 'Insert Username',
  insertPassword: 'Insert Password',
  insertEmail: 'Insert Email',
  enterYourEmailToResetYourPassword: 'Enter your email to reset your password.',
  enterNewPassword: 'Enter New Password',
  confirmPassword: 'Confirm Password',
  passwordMustBeAtLeast8CharactersAndContainAtLeastOneUppercaseLetterAndOneNumber:
    'Password must be at least 8 characters and contain at least one uppercase letter one number and one special character.',
  passwordsMustMatch: 'Passwords must match',

  'Select Position': 'Select Position',
  'Compliance Officer': 'Compliance Officer',
  Administrator: 'Administrator',
  HR: 'HR',
  COMPLIANCE_OFFICER: 'Compliance Officer',
  ADMINISTRATOR: 'Administrator',

  chooseResolutionOption: 'Choose resolution option',
  'Case Dismissed': 'Case Dismissed',
  Lawsuit: 'Lawsuit',
  'Report to Other Authorities': 'Report to Other Authorities',
  'Resolved Internally': 'Resolved Internally',

  IhaveReadAndAgreeWithThe: 'I have read and accepted the',
  iHaveReadAndUnderstoodThe: 'I have read and understood the',
  iHaveReadAndUnderstoodTheLicenseAgreement:
    'I have read, understood and fully consent to the',
  endUserLicenseAgreement: 'End User License Agreement',
  privacyPolicy: 'Privacy Policy',
  termsAndConditions: 'Terms and Conditions',
  IhaveBeenInformedAboutTheProcessingOfMyData:
    'I have been informed about the processing of my personal data, pursuant to the',
  privacyStatement: 'Privacy Statement',
  Jan: 'Jan',
  Feb: 'Feb',
  Mar: 'Mar',
  Apr: 'Apr',
  May: 'May',
  Jun: 'Jun',
  Jul: 'Jul',
  Aug: 'Aug',
  Sep: 'Sep',
  Oct: 'Oct',
  Nov: 'Nov',
  Dec: 'Dec',

  CASE_DISMISSED: 'Case Dismissed',
  LAWSUIT: 'Lawsuit',
  REPORT_TO_OTHER_AUTHORITIES: 'Report to Other Authorities',
  RESOLVED_INTERNALLY: 'Resolved Internally',

  tooltipLogo:
    'The company logo will be shown when a whistleblower submits a report to your company.',
  somethingWentWrongPleaseTryAgain: 'Something went wrong, please try again.',
  reviewPlan: 'Review Plan',
  billing: 'Billing',
  changePlan: 'Change plan',
  next: 'Next',
  payNow: 'Pay now',
  email: 'Email',
  username: 'Username',
  detailsDescription:
    'Enter your Details. An account will automatically be generated once payment is completed.',
  billingInformation: 'Billing Information',
  billingInformationDescription:
    'Enter your Billing Information in order to complete Payment. The name and address appear on your invoices. You will be safely redirected to Stripe.',
  companyName: 'Legal company name',
  companyEmail: 'Company email',
  companyTaxId: 'Company VAT ID',
  country: 'Country',
  state: 'State',
  city: 'City',
  postalCode: 'Postal Code',
  address1: 'Address 1',
  address2: 'Address 2',
  subscriptionEod: 'Subscription EOD',
  loginToYourAccount: 'Login to your account',
  paymentSuccessTitle: 'Your payment was successful',
  paymentSuccessText:
    'We have received your payment and have sent you an email with your login credentials.',
  planAndBilling: 'Plan & Billing',
  youAreOnThe: 'You are on the',
  membershipPlan: 'membership plan',
  thisSubscriptionIsValidTill: 'This subscription is valid till',
  itWillAutomaticallyRenew:
    'It will automatically renew at the end of the billing period, unless the subscription is cancelled beforehand.',
  thePriceOfMembership: 'The price for membership is',
  plusVat: '+VAT',
  myPlan: 'My Plan',
  myInvoices: 'My Invoices',
  cancelSubscription: 'Cancel Subscription',
  reActivateSubscription: 'Reactivate Subscription',
  cancelSubscriptionDescription:
    'Are you sure you want to cancel your subscription? It will remain active until the end of the billing period. You can reactivate it at any time before the end of the billing period.',
  reactivateSubscriptionDescription:
    'Are you sure you want to reactivate your subscription? You can cancel it again at any time before the end of the billing period.',
  subscriptionCancelled:
    'Subscription will be canceled at the end of the billing period',
  subscriptionReactivated:
    'Subscription cancellation has been reversed. Your subscription will continue',
  // Cancellation feedback. The reason is required by us, not by the backend,
  // which accepts a cancellation without one - see ModalCancelSubscription.
  whyAreYouCancelling: 'Why are you cancelling?',
  selectAReason: 'Select a reason',
  anythingElseYouWouldLikeToTellUs: 'Anything else you would like to tell us?',
  notGiven: 'Not given',
  itWillBeCancelledAtTheEndOfTheBillingPeriod:
    'It will be cancelled at the end of the billing period.',
  chargeDate: 'Charge date',
  billingPeriod: 'Billing period',
  amount: 'Amount',
  user: 'User',
  company: 'Company',
  personalInformationHasBeenUpdated:
    'Your personal information has been updated successfully',
  duplicateEmail: 'This email is already in use',
  duplicateUsername: 'This username is already in use',
  save: 'Save',
  edit: 'Edit',
  delete: 'Delete',
  cancel: 'Cancel',
  personalInformation: 'Personal Information',
  general: 'General',
  security: 'Security',
  update: 'Update',
  companyProfile: 'Company Profile',
  billingInformationHasBeenUpdated:
    'Your billing information has been updated successfully',
  yourPlan: 'Your Plan',
  expiresIn: 'Expires in',
  youHaveSelectedThe: 'You have selected the',
  month: 'month',
  months: 'months',
  yourUniversity: 'university',
  students: 'students',
  employees: 'employees',
  upTo: 'up to',
  upTo2: 'Up to',
  moreThan: 'more than',
  moreThan2: 'More than',
  seatsPlanDescription:
    'This plan is to register {{range}} {{seats}} {{unit}} of your {{productType}}.',
  myPlanDescription:
    'This subscription is for {{months}} {{monthsLabel}} and includes: €{{price}} for the first {{months}} {{monthsLabel}} - after this period, a recurring fee of €{{price}} will be charged for the following {{months}} {{monthsLabel}}, unless the subscription is cancelled before the end of the period.',
  changePlanDescription:
    'Select the plan that suits your business demands depending on the functionalities you need and how many employees/students your organization has. The new billing period will start at the end of current billing period.',
  selectYourPlanTitle: 'Select your plan',
  selectYourPlanDescription:
    'Select the plan that suits your business demands depending on the functionalities you need and how many employees/students your organization has.',
  studentsUnit: 'students',
  employeesUnit: 'employees',
  companies: 'Companies',
  universities: 'Universities',
  standardPlanTitle: 'Standard',
  monthly: 'Monthly',
  yearly: 'Yearly',

  // Super admin cancellations table
  cancellations: 'Cancellations',
  plan: 'Plan',
  reason: 'Reason',
  comment: 'Comment',
  cancelledBy: 'Cancelled by',
  cancelledOn: 'Cancelled on',
  accessEnds: 'Access ends',
  allReasons: 'All reasons',
  allCancellations: 'All cancellations',
  reversed: 'Reversed',
  stillStanding: 'Still standing',
  noCancellationsFound: 'No cancellations found',
  annually: 'Yearly',
  vatExclusive: 'excl VAT',
  featureFullAnonymity: 'Full Anonymity',
  featureCompliance: 'Compliance',
  featureLocalization: 'Localization',
  featureFollowUp: 'Notifications',
  featureConfigurations: 'Configurations',
  featureUserRoles: 'User Roles',
  featureIdentityProtection: 'Identity Protection',
  featureReportsManagement: 'Reports Management & Log',
  featureCustomLogo: 'Custom Logo',
  featureCustomerSupport: 'Customer Support',
  featureAttachments: 'Attachments',
  getStartedButton: 'Get Started',
  activePlan: 'Active plan',
  cancelPlanUpdate: 'Cancel plan update',
  planChangedSuccessfully: 'Plan changed successfully',
  failedToChangePlan: 'Failed to change plan',
  planChangeCancelledSuccessfully: 'Plan change cancelled successfully',
  failedToCancelChangePlan: 'Failed to cancel plan change',
  pending: 'Pending',
  upToDescription: '{{range}} {{seats}} {{unit}} of your {{productType}}.',
  pendingPlanDescription:
    'The updated subscription starts on {{startingDate}}. This subscription is valid for {{months}} {{monthsLabel}}. It will automatically renew at the end of the billing period, unless the subscription is cancelled beforehand.',
  allFieldsAreRequired: 'All fields are required',
  allConsentsRequired:
    'You must accept the Terms & Conditions, Privacy Policy, and End User License Agreement.',
  pleaseFillAllTheRequiredFields: 'Please fill all the required fields',
  noCategoriesFoundInitial:
    'No categories yet. Create one first so people can create new reports.',
  payment: 'Payment',
  confirm: 'Confirm',
  paymentInformation: 'Payment Information',
  paymentInformationDescription:
    'Please select the payment method to complete your Purchase. For Card payment you will be safely redirected to Stripe.',
  cardPayment: 'Card payment',
  manualBankTransfer: 'Bank transfer',
  organizations: 'Organisations',
  transactions: 'Transactions',
  noOrganizationsFound: 'No Organisations Found',
  active: 'Active',
  organization: 'Organisation',
  subscription: 'Subscription',
  paymentMethod: 'Payment method',
  subscriptionPeriod: 'Subscription Period',
  companyNameColumn: 'Company Name',
  invoiceNo: 'Invoice No.',
  method: 'Method',
  card: 'Card',
  manualPayment: 'Manual payment',
  noTransactionsFound: 'No Transactions Found',
  selectDateRange: 'Select date range',
  viewTransactions: 'View transactions',
  activateAccount: 'Activate Account',
  updateEod: 'Update EOD',
  updateEodDescription:
    'Set a new subscription end date for this organisation.',
  accountActivatedSuccessfully: 'Account activated successfully',
  provisionalPeriod: 'provisional',
  provisionalPeriodNote:
    'Provisional period for an unconfirmed bank transfer. The subscription runs from the date the payment is confirmed.',
  noSubscriptionToActivate:
    'No subscription found for this organisation, so there is nothing to activate.',
  failedToActivateAccount: 'Failed to activate account',
  subscriptionEodUpdated: 'Subscription end date updated',
  failedToUpdateSubscriptionEod: 'Failed to update subscription end date',
  noOrganizationsUsersFound: 'No Users Found',
  download: 'Download',
  view: 'View',
  expand: 'Expand',
  collapse: 'Collapse',
  value: 'Value',
  mailAddress: 'Mail address',
  sendMessage: 'Send Message',
  support: 'Support',
  howCanWeHelpYou: 'How can we help you?',
  supportFormTitle:
    'Please fill out the form below to get the conversation started.',
  supportFormDescription:
    'Our support team typically responds to emails within one business day.',
  subject: 'Subject',
  supportSubjectPlaceholder: 'What is your message about?',
  subjectMustBeAtLeast5Characters: 'Subject must be at least 5 characters long',
  messageMustBeAtLeast10Characters:
    'Message must be at least 10 characters long',
  supportMessageLabel: 'Tell us what you need help with and how we can help',
  yourMessageHere: 'Your message here',
  supportMessageSent: 'Your message has been sent',
  failedToSendSupportMessage: 'Failed to send your message',
  exit: 'Exit',
  goToLogin: 'Go to Login',
  bankTransferSentTitle:
    'An email has been sent to the registered Company email.',
  bankTransferSentDescription:
    'Please follow the instructions in the email and complete the payment as soon as possible. Your ReportAll account will only be activated after receipt of payment. You can still view your subscription and settings, but full access will be available after activation.',
  planUpdateNotActiveBanner:
    'ReportAll Plan update is not yet active. We will contact you once your payment has been received and your new Membership plan is activated.',
  accountNotActivatedBanner:
    'Activation of your ReportAll account has not yet been completed. Please make your payment and notify us to confirm the activation.',
  accountAwaitingActivationAdmin:
    'Your account is awaiting activation. Confirm your payment to restore full access.',
  disabledUntilActivation: 'Not available until your account is activated.',
  confirmPayment: 'Confirm Payment',
  paymentOptions: 'Payment Options',
  managePaymentMethod: 'Manage your payment method.',
  showSubscriptionBankDetails: 'Show Subscription Bank Details',
  hideSubscriptionBankDetails: 'Hide Subscription Bank Details',
  accountAwaitingActivation:
    'Your organisation is awaiting activation. Please contact your administrator.',
  invoiceHistoryNote:
    'Invoice history can only be accessed for the previous 3 years via Account. Please contact Customer Support if you wish to access invoice history prior to this time period.',
  noInvoicesFound: 'No invoices found',
  paymentConfirmationSent: 'Payment confirmation sent',
  failedToConfirmPayment: 'Failed to send payment confirmation',
  tryAgain: 'Try again',
  failedToLoadInvoices: 'Failed to load invoices',
  failedToLoadPlan: 'Failed to load your plan',
  noActiveSubscription: 'No active subscription found',
  subscriptionManagedBySupport:
    'Your subscription is paid by bank transfer and is managed by the ReportAll team. Please contact support to change or cancel your plan.',
  failedToLoadBillingInformation: 'Failed to load billing information',
  noBillingInformationFound: 'No billing information found',
  currentPasswordIsIncorrect: 'Current password is incorrect',
  currentPassword: 'Current Password',
  newPassword: 'New Password',
  reEnterNewPassword: 'Re-enter New Password',
  keepMeSignedIn: 'Keep me signed in',
  sort: 'Sort',
  allStatuses: 'All statuses',
  allMethods: 'All methods',
}
